module.exports = __webpack_public_path__ + "img/envelope_white.de2749fc.svg";